import React from 'react';
import { ContentBlock } from '../../../../common/index.jsx';
import PollBlockResultChart from '@/components/layout/PublicLayout/Components/Polls/PollResult/PollResultChart';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PollResults = ({ data, pollText }) => {
  const { t } = useTranslation();

  return (
    <div className="news-detail-page-container add-icons-to-file-anchors">
      <ContentBlock
        contentVisible
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        title={data.name}
      >
        <h4
          style={{
            paddingBottom: '1em',
          }}
        >
          {pollText}
        </h4>
        <PollBlockResultChart pollId={data.id} />
      </ContentBlock>
    </div>
  );
};

PollResults.propTypes = {
  pollId: PropTypes.number,
  data: PropTypes.any,
  pollText: PropTypes.string,
};
export default PollResults;
